import moment from 'moment';
import { getDisponibilites } from '@/api/dispo/index';
import * as dateConf from '@/configuration/datePickerConf';
import ucFirst from '@/services/general/ucFirst';

function isNewMonth(month, actualMonth) {
  if (month === actualMonth) return false;
  return true;
}

export default async function getDispoReseauAnnee(produitId, annee) {
  const response = await getDisponibilites(produitId, annee);
  const dispoReseau = [];
  let semaine = 1;
  let actualMonth = 0;
  response.data.result.forEach((dispoParSemaine) => {
    const dateDebut = new Date(dispoParSemaine.date);
    let semaineActuelle = false;
    dateDebut.setDate(dateDebut.getDate() - 6);
    if (dispoParSemaine.jourDepart > 6) dispoParSemaine.jourDepart = 6;
    if (dispoParSemaine.jourDepart > 12) dispoParSemaine.mois = 12;
    const dateCourante = moment(new Date());
    if (dateCourante.week() === semaine
      && annee === dateCourante.weekYear()) semaineActuelle = true;
    dispoReseau.push({
      semaine: 'S' + semaine,
      facePrevus: dispoParSemaine.stock,
      jour: ucFirst(dateConf.LISTE_JOURS_LONG[dispoParSemaine.jourDepart]),
      mois: ucFirst(dateConf.LISTE_MOIS[dispoParSemaine.mois - 1]),
      newMonth: isNewMonth(dispoParSemaine.mois, actualMonth),
      anneeSemaine: dispoParSemaine.anneeSemaine,
      dateFin: new Date(dispoParSemaine.date),
      dateDebut: dateDebut,
      jourDeDepart: dispoParSemaine.jourDepart,
      semaineActuelle: semaineActuelle,
      produitId: dispoParSemaine.produitId,
      objectif: dispoParSemaine.objectif,
    });
    if (actualMonth !== dispoParSemaine.mois) actualMonth = dispoParSemaine.mois;
    semaine += 1;
  });
  return dispoReseau;
}
